/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: Solo = 1, RoundRobin = 2
 */
export enum Routemize_Constants_EventNature {
    SOLO = 'Solo',
    ROUND_ROBIN = 'RoundRobin',
}
